import { Empty } from 'antd';
import styled, { useTheme } from 'styled-components';
// import useNoticeBoardController from '../../../1_application/dashboard/noticeBoardController';
import BoxContainer from '../../core/components/box/boxContainer';
import Column from '../../core/components/box/column';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import LXSpinner from '../../core/spinner/lx_spinner';
import { LXbody, LXCaption, LXh4 } from '../../core/texts/lxText';

const NoticeListItem = styled.div`
  display: flex;

  font-family: 'Outfit';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  height: 18px;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => props.color ?? props.theme.colors.body};
  margin-bottom: 10px;
  &:marker {
    margin-right: 0;
  }
`;

const Notice = ({
  width,
  height,
  fromDate,
  endDate,
}: {
  width?: string;
  height?: string;
  fromDate?: Date;
  endDate?: Date;
}) => {
  const theme = useTheme();
  /** uncomment to get notice */
  // const n = useNoticeBoardController(fromDate, endDate);
  const n: any = { noticeList: [] };

  const makeNoticeListMaximumFive = () => {
    return n.noticeList.map((notice: any) => (
      <NoticeListItem key={notice.id}>
        <LXbody
          onClick={n.navigateToNoticeId(notice.id)}
        >{`• ${notice.title}`}</LXbody>
      </NoticeListItem>
    ));
  };

  if (n.loading)
    return (
      <BoxContainer width={width} height={height}>
        <LXSpinner></LXSpinner>
      </BoxContainer>
    );
  return (
    <BoxContainer width={width} height={height} padding="24px 30px 30px 30px">
      <Column>
        <Row justifyContent="space-between" alignItems="center">
          <LXh4>{theme.texts.notice}</LXh4>
          <LXCaption
            onClick={n.navigateToNoticeList}
            color={theme.colors.primary500}
          >
            {theme.texts.seeAll}
          </LXCaption>
        </Row>
        <SizedBox height={40}></SizedBox>
        {n.noticeList.length === 0 ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          makeNoticeListMaximumFive()
        )}
      </Column>
    </BoxContainer>
  );
};

export default Notice;
